"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var aws_amplify_1 = __importDefault(require("aws-amplify"));
// This is only including setting we are using.
// For a full list visit: https://aws-amplify.github.io/docs/js/authentication
function configure(region, userPoolId, userPoolWebClientId) {
    aws_amplify_1.default.configure({
        Auth: {
            region: region,
            userPoolId: userPoolId,
            userPoolWebClientId: userPoolWebClientId,
            authenticationFlowType: "USER_PASSWORD_AUTH"
        }
    });
}
exports.configure = configure;
